<template>
  <div id="buy-live-game" >
    <div class="data-box">
      <div class="data-content">
        <div class="remain-count">{{totalAmount}}<span class="note">场</span></div>
        <div class="used-count"><span>总剩余直播</span><span class="used-note">已直播 <span class="note">{{usedAmount}}场</span></span></div>
      </div>
    </div>
    <div class="app-box">
      <img class="img-box" src="@/assets/images/bmlive@2x.png">
      <div class="text-msg">
        <div>所有场次需要使用<span class="note">[斑马赛事通]</span>App进行直播</div>
        <div>请前往斑马赛事通</div>
      </div>
    </div>
    <div class="actions" @click="goAppStore">
      <div>打开斑马赛事通</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { getBMUserLiveAccountBalanceInfo } from '@/api/pay'
// import { AppType } from '@/utils'
import { Row, Col, RadioGroup, Radio, Field, Toast, Popup, Button } from 'vant'

Vue.use(Row).use(Col).use(RadioGroup).use(Radio).use(Field).use(Toast).use(Popup).use(Button)

export default {
  name: 'Buy',
  data() {
    return {
      totalAmount: 0,
      usedAmount: 0
    }
  },
  created() {
    this.loadData()
  },
  computed: {},
  methods: {
    loadData() {
      getBMUserLiveAccountBalanceInfo().then(response => {
        const data = response && response.data
        if (response) {
          this.totalAmount = data.totalAmount
          this.usedAmount = data.usedAmount
        }
      })
    },
    goAppStore() {
      window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=cn.snsports.match'
    }
  }
}
</script>

<style lang="stylus" >
#buy-live-game
  width 100%
  .data-box
    padding: 10px;
    .data-content
      box-shadow:0px 4px 6px 1px rgba(0,0,0,0.05);
      border-radius:2px;
      height: 104px;
      .remain-count
        font-size: 35px
        color: #38906B;
        padding-top: 30px;
        padding-left: 30px;
        .note
          font-size: 12px;
          color: #8a8a8a;
      .used-count
        color: #8a8a8a;
        font-size: 12px;
        padding-left: 30px;
        padding-top: 5px;
        .used-note
          float: right;
          position: relative;
          right: 20px;
          .note
            color: #4a4a4a;
  .app-box
    padding-top: 80px;
    color: #4a4a4a;
    font-size: 14px;
    text-align: center;
    .img-box
      width:70px;
      height: 70px;
    .text-msg
      margin-top: 24px;
      .note
        color: #000;
  .actions
    color: #FFF;
    height: 55px;
    line-height: 55px;
    background-color:  #38906b;
    width: 100%;
    position: fixed;
    bottom: 0;
    text-align: center;
    font-size: 20px;

</style>



// WEBPACK FOOTER //
// src/pages/buy/live-game.vue